import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class Experiments {
  constructor(specs) {
    _defineProperty(this, "specs", void 0);
    this.specs = specs || {};
  }
  is(key, value) {
    return this.specs[key] === value;
  }
  enabled(key) {
    return this.specs[key] === 'true';
  }
  get() {
    return this.specs;
  }
  getSpec(key) {
    return this.specs[key];
  }
}
export * from './specs';
export * from './types';
//# sourceMappingURL=index.js.map